/* =========================================================
   SCA — CUSTOM PREMIUM HEADER JS
   Normal header → conversion nav + mobile menu
========================================================= */

(function () {
  function initScaHeader() {
    const header = document.querySelector('[data-sca-header]');
    if (!header || header.dataset.scaHeaderReady === 'true') return;

    header.dataset.scaHeaderReady = 'true';

    const mobileToggle = header.querySelector('[data-sca-mobile-toggle]');
    const mobileDrawer = header.querySelector('[data-sca-mobile-drawer]');

    let lastScrollY = window.scrollY;
    let ticking = false;

    const conversionOffset = 260;
    const topResetOffset = 80;
    const minDelta = 6;

    function openMobileMenu() {
      if (!mobileToggle || !mobileDrawer) return;

      header.classList.add('is-mobile-open');
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileDrawer.setAttribute('aria-hidden', 'false');

      document.documentElement.classList.add('custom-header-is-open');
      document.body.classList.add('custom-header-is-open');
    }

    function closeMobileMenu() {
      if (!mobileToggle || !mobileDrawer) return;

      header.classList.remove('is-mobile-open');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileDrawer.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('custom-header-is-open');
      document.body.classList.remove('custom-header-is-open');
    }

    function showNormalHeader() {
      header.classList.remove('is-normal-hidden');
      header.classList.remove('is-conversion-visible');
    }

    function showConversionHeader() {
      header.classList.add('is-normal-hidden');
      header.classList.add('is-conversion-visible');
    }

    function hideAllHeaders() {
      header.classList.add('is-normal-hidden');
      header.classList.remove('is-conversion-visible');
    }

    function handleScroll() {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      if (header.classList.contains('is-mobile-open')) {
        ticking = false;
        return;
      }

      if (currentScrollY <= topResetOffset) {
        showNormalHeader();
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (Math.abs(delta) < minDelta) {
        ticking = false;
        return;
      }

      if (currentScrollY > conversionOffset) {
        showConversionHeader();
      } else if (delta > 0) {
        hideAllHeaders();
      } else {
        showNormalHeader();
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function requestScrollTick() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', function () {
        if (header.classList.contains('is-mobile-open')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      mobileDrawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMobileMenu);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 980) {
        closeMobileMenu();
      }

      if (window.scrollY <= topResetOffset) {
        showNormalHeader();
      } else if (window.scrollY > conversionOffset) {
        showConversionHeader();
      }
    });

    window.addEventListener('scroll', requestScrollTick, { passive: true });

    if (window.scrollY <= topResetOffset) {
      showNormalHeader();
    } else if (window.scrollY > conversionOffset) {
      showConversionHeader();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScaHeader);
  } else {
    initScaHeader();
  }

  document.addEventListener('shopify:section:load', function () {
    const header = document.querySelector('[data-sca-header]');
    if (header) {
      header.dataset.scaHeaderReady = 'false';
    }

    initScaHeader();
  });
})();